module.exports = {

    appPort: 8030,

    defaultContentType: 'application/x-www-form-urlencoded',

    requestTimeout: 5000,

    title: '蛮筷云店',

    fixedHeader: false,

    logo: '/logo.png',

    sidebarLogo: true,

    tagsView: true,

    noPermission: 'no_user',
    uploadUrl: 'https://cloud.stores.mankuaiaa.cn/api',
    resourcesPath: 'https://cloud.stores.mankuaiaa.cn',
    userRoute: "",
    riceMachineRoute: "",
    shopRoute: "",
    retailMachineRoute: ""
}
